import { Link } from "react-router-dom";
import styles from "../../../styles/admin.module.css";

const Admin = () => {

    return ( 
        <>
        <h2 className={styles.title}>Admin Panel</h2>
        <p className={styles.info}>Warning: This controls the crucial part of this website, do not use without proper authorization</p>
        <ul className={styles.wrapper}>
            <Link to="/admin/events" className={styles.navlink}>
            {" "}
            <li>Manage Events</li>
          </Link>
        
            <Link to="/admin/blogs" className={styles.navlink}>
            {" "}
            <li >Manage Blogs</li>
          </Link>
          </ul>
        </>
     );
}
 
export default Admin;
